<template>
  <span class="fleet-run-hand-back-menu" @click.stop @keydown.stop>
    <WFlyout :components="items" position="left" :section-tag="sectionTag" @item-clicked="handleChoice">
      <template #activator="{ props: activatorProps }">
        <WButton
          v-bind="activatorProps"
          variant="icon"
          :icon="mdiDotsVertical"
          :label="`Hand back run ${runId}`"
          :color="tokens.color.action.primary.surface"
          :section-tag="`${sectionTag}-flyout`"
          @click="handBack.open(runId)"
        />
      </template>
      <template #item-renderer="{ props: { item } }">
        <span :title="helpOf(item)">{{ item.title }}</span>
      </template>
    </WFlyout>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useFleetRunHandBack } from '@/composables/useFleetRunHandBack'

import { handBackMenuItems } from '@/services/claude-fleet'
import type { FleetRunMenuItem } from '@/services/claude-fleet'

import WButton from '@wasabi/actions/WButton.vue'
import WFlyout from '@wasabi/content-displays/WFlyout.vue'

import { mdiDotsVertical } from '@mdi/js'

import { tokens } from '@/plugins/vuetify'

/** Hand back and Run it on mine for a running run, where a place lists the run without its full ⋮ menu. */
const props = defineProps<{ runId: string; sectionTag: string }>()

const handBack = useFleetRunHandBack()

const items = computed(() => handBackMenuItems(handBack.checkOf(props.runId)))

function helpOf(item: { key?: unknown }): string | undefined {
  return items.value.find(menuItem => menuItem.key === item.key)?.help
}

function handleChoice(item: FleetRunMenuItem) {
  const chosen = items.value.find(menuItem => menuItem.key === item.key)
  if (!chosen || chosen.disabled) return
  if (chosen.key === 'hand-back') void handBack.choose(props.runId, 'anyone')
  if (chosen.key === 'run-on-mine') void handBack.choose(props.runId, 'mine')
}
</script>
